import { render, staticRenderFns } from "./GerenciamentoProdutosLoja.vue?vue&type=template&id=27e1d3ff&scoped=true"
import script from "./GerenciamentoProdutosLoja.vue?vue&type=script&lang=js"
export * from "./GerenciamentoProdutosLoja.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoProdutosLoja.vue?vue&type=style&index=0&id=27e1d3ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1d3ff",
  null
  
)

export default component.exports